import State from '@/state/State';

// US routes to partner-specific inboxes; every other country falls back to UK support.
export const getSupportEmail = (countryCode, partnership) => {
  if (countryCode === 'US') {
    if (partnership === 'lip') {
      return 'instantpaysupport@wagestream.com';
    }
    if (partnership === 'osv') {
      return 'mfppartners@wagestream.com';
    }
    return 'usclientsupport@wagestream.com';
  }

  return 'clients.uk@support.stream.co';
};

export const getCompanySupportEmail = () => {
  const properties = State.state.company?.properties;
  return getSupportEmail(properties?.payment_country_code, properties?.partnership);
};

export const contactSupport = () => {
  if (typeof window.FrontChat === 'undefined') {
    location.href = `mailto:${getCompanySupportEmail()}`;
  } else {
    window.FrontChat('show');
  }
};
